import { Component } from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {RouterModule, Routes} from '@angular/router';

@Component({
  selector: 'app-preorders-management',
  imports: [
    RouterModule,
    MatCardModule,
  ],
  templateUrl: './preorders-management.component.html',
  styleUrl: './preorders-management.component.scss'
})
export class PreordersManagementComponent {

}
